module.exports = __webpack_public_path__ + "img/bill.4d69b472.png";